import { ButtonBase, styled as muiStyled } from '@mui/material'

export const HowItWorksCardContainer = muiStyled('div')(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 1308px;
    margin: 0 auto;
    padding: 34px 54px 50px;
`,
)

export const HowItWordsInnerCardsContainer = muiStyled('div')(
  ({ theme }) => `
    display: grid;
    gap: 20px;
    width: 100%;
    grid-template-columns: 1fr;
    @media (min-width: 768px) {
      gap: 54px;
      grid-template-columns: 1fr 1fr;
    }
`,
)

export const GetYourPlanButton = muiStyled(ButtonBase)(
  ({ theme }) => `
  background-color: #cad2fe;
  color: #000;
  padding: 10px 20px;
  border-radius: 30px;
  font-weight: 700;
  letter-spacing: 2px;
  transition: background-color 300ms ${theme.transitions.easing.quickInOut};
  font-size: 20px;
  &:hover{
    background-color: #a9b8f9;
  }
  @media (min-width: 768px) {
    font-size: 24px;
`,
)
